
import React from 'react';
import ContactForm from './ContactForm';
import ContactOptions from './ContactOptions';
import SectionHeader from '@/components/SectionHeader';
import TechBackground from '@/components/ui/TechBackground';
import SectionTransition from '@/components/ui/SectionTransition';

const Contact = () => {
  return (
    <section id="contact" className="py-4 md:py-6 relative overflow-hidden">
      {/* Subtle texture pattern for background */}
      <div className="absolute inset-0 bg-[#001026] bg-opacity-90 z-0">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNDB2NDBoLTQweiIvPjxwYXRoIGQ9Ik0wIDBoMXY0MGgtMXpNMzkgMGgxdjQwaC0xek0wIDBoNDB2MWgtNDB6TTAgMzloNDB2MWgtNDB6IiBmaWxsPSJyZ2JhKDI1NSwgMjU1LCAyNTUsIDAuMDUpIi8+PC9nPjwvc3ZnPg==')] opacity-20"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMSIgZmlsbD0iI2ZmZmZmZiIgZmlsbC1vcGFjaXR5PSIwLjA1Ii8+PC9zdmc+')] opacity-40"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <SectionHeader
          title="Get In Touch"
          subtitle="Let's discuss how we can help your business grow"
          emoji="📬"
          titleColor="text-white"
        />

        <SectionTransition type="scale" delay={0.1} className="mt-4 md:mt-6">
          <TechBackground variant="dark" glow="blue" className="p-4 md:p-6 max-w-5xl mx-auto">
            <div className="mb-4">
              <ContactOptions />
            </div>
            
            <div>
              <ContactForm />
            </div>
            
            {/* Tech-style decorative elements */}
            <div className="absolute top-6 right-6 w-12 h-12 border border-white/20 rounded-lg grid grid-cols-3 grid-rows-3 gap-0.5 opacity-30">
              {[...Array(9)].map((_, i) => (
                <div key={i} className="bg-white/10 rounded-sm"></div>
              ))}
            </div>
          </TechBackground>
        </SectionTransition>
      </div>
    </section>
  );
};

export default Contact;
